import { Component, Vue, Ref } from "vue-property-decorator";
import { StockInOrderServiceProxy,StockInTypeServiceProxy, StockOutOrderServiceProxy } from "@/service-proxies/app-v2/wms.service-proxies"
import { EmployeeSearchDTO, EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies"
import { AuthorityDomainServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies';
import InnerBody from './components/InnerBody'
import InnerBodys from './components/InnerBodys'
import CreatModal from './components/CreatModal/CreatModal.vue'
import EditModal from './components/EditModal/EditModal.vue'
import CodeModel from '@/components/CodeModel/index.vue'

const soosp = new StockOutOrderServiceProxy()
const ssp = new SupplierServiceProxy()
const siosp = new StockInOrderServiceProxy()
const esp = new EmployeeServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
const skitsp = new StockInTypeServiceProxy()
@Component({
  components: {
    InnerBody,
    InnerBodys,
    CreatModal,
    EditModal,
    CodeModel
  }
})
export default class Alarm extends Vue {
  StockInOrderData = []
  selectedRowKeys = []
  addNewVisible = false
  editVisible = false
  searchKey = ""
  dataOutOrder = []
  paginationOrder = {
    pageSize: 10,
    current: 1
  }
  selectId = ""
  staff = []
  depts = []
  defaultData = {}
  selectData:any = {}
  areaId = ""
  total = 0
  stockInList = []
  canEdit = true
  listAllTree = []
  height = 300
  tableScrollHeight = 300
  supplierList = [] // 供应商列表
  stockOutOrderList = [] // 出库单列表
  resizeTimer = null
  printVisible = false
  dataList = []

  mounted() {
    this.$nextTick(() => {
      this.getList()
      this.getStaff()
      this.getDepts()
      this.getStockIn()
      this.getSupplierList()
      this.getStockOutOrder()
    })
  }
  
  getSupplierList(){
    ssp.getPageSupplier(1,"",999999).then(res =>{
      this.supplierList = res.records
    })
  }

  getStockOutOrder(){
    const wmsRouters = this.$store.getters.wmsRoutes
    const areaId = (this.$route.query.materialId ? this.$route.query.materialId : ((wmsRouters && wmsRouters[0] && wmsRouters[0].id))).toString()
    soosp.pageStockOutOrder(areaId,1,"",999999).then(res =>{
      this.stockOutOrderList = res.records
    })
  }

  updated(){
    const div = document.body.clientHeight
    this.height = (div - 360) /2
    this.tableScrollHeight = (div - 350) /2
    console.log(this.height)
  }

  async getStaff() {
    const data = await esp.getEmployeeList({statusList: [1]} as EmployeeSearchDTO)
    this.staff = data
  }

  async getDepts() {
    const { data } = await adsp.getAssignedTreeList()
    const depts = []
    data.forEach(item => {
      depts.push(this.filterData(item))
    })
    this.depts = depts
  }

  getStockIn(){
    skitsp.getStockInTypeList().then(res =>{
      this.stockInList = res
    })
  }

  filterData(item: any) {
    const arr = {
      title: item.title,
      value: item.id,
      key: item.id,
      children: [],
    }
    this.listAllTree.push(arr)
    if (item.children && item.children.length > 0) {
      item.children.forEach(res =>{
        arr.children.push(this.filterData(res))
      })
    } else {
      delete item.children;
    }
    return arr;
  }

  async getList(){
    this.selectData = []
    const wmsRouters = this.$store.getters.wmsRoutes
    this.areaId = (this.$route.query.materialId ? this.$route.query.materialId : ((wmsRouters && wmsRouters[0] && wmsRouters[0].id))).toString()
    const res = await siosp.getPageStockInOrder(this.areaId,this.paginationOrder.current, false,this.searchKey,this.paginationOrder.pageSize)
    this.dataOutOrder = res && res.records || []
    this.total = Number(res.total)
    if(res.records && res.records.length > 0){
      if(this.selectId !== ""){
        const data = res.records.find(res => res.id === this.selectId)
        this.onClickRow(data)
      } else {
        this.onClickRow(res.records[0])
      }
    }
  }

  reload(){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.StockInOrderData = []
    this.addNewVisible = false
    this.getList()
  }

  async close() {
    await siosp.closeInOrder(this.selectedRowKeys)
    this.$message.success(this.$t("page_material_warehousing_close_success"))
    this.reload()
  }

  delete() {
    siosp.deleteStockInOrder(this.selectedRowKeys).then(() =>{
      this.$message.success(this.$t("delete_success"))
      this.selectId = ""
      this.reload()
    })
  }

  onSearch(value) {
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.searchKey = value
    this.getList()
  }

  addNew(){
    this.defaultData = {}
    this.addNewVisible = true
  }

  async editItem() {
    this.defaultData = this.selectData
    this.editVisible = true
  }

  addClose(){
    this.addNewVisible = false
  }

  editClose(){
    this.editVisible = false
  }

  onSelectChange(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys;;
    if(selectedRowKeys.length == 1 ){
      const id = selectedRowKeys[0]
      const record = this.dataOutOrder.find(res => res.id === id)
      this.onClickRow(record)
    }
  }

  handleTableChange(data) {
    this.paginationOrder = {
      pageSize: data.pageSize,
      current: data.current
    }
    this.getList()
  }

  onClickRow(record){
    this.selectId = record.id
    this.selectedRowKeys = [record.id]
    if(record.orderStatus == 2 || record.orderStatus == 3){
      this.canEdit = true
    } else {
      this.canEdit = false
    }
    siosp.getStockInOrder(this.selectId).then(res =>{
      this.selectData = res
      this.StockInOrderData = res.stockInOrderMaterialVoList
    })
  }

  reloadEdit(){
    this.getList()
  }
  
  beforeDestroy(){
    clearTimeout(this.resizeTimer)
  }

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }

  printing() {
    this.getData()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }

  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.dataOutOrder.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.orderCode,
            name: item.orderName
          })
        }
      })
    })
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_material_warehousing_new') }</a-button>
            <a-button type="default" disabled={this.canEdit || this.selectedRowKeys.length !== 1} style="margin-right: 8px;" onClick={() => this.editItem()}>{ this.$t('edit') }</a-button>
            <a-popconfirm title={this.$t('close_tips')} onConfirm={() => this.close()}>
              <a-button type="default" disabled={this.selectedRowKeys.length !== 1} style="margin-right: 8px;">{ this.$t('close') }</a-button>
            </a-popconfirm>
            <a-popconfirm title={ this.$t('delete_tips')} onConfirm={() => this.delete()}>
              <a-button type="danger" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('delete') }</a-button>
            </a-popconfirm>
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <div id="ware-topmodal" style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-body
              height={this.tableScrollHeight}
              listAllTree={this.listAllTree}
              selectId={this.selectId}
              selectedRowKeys={this.selectedRowKeys}
              staff={this.staff}
              data={this.dataOutOrder}
              current={this.paginationOrder.current}
              pageSize={this.paginationOrder.pageSize}
              total={this.total}
              onOnSelectChange={value => this.onSelectChange(value) }
              onHandleTableChange={value => this.handleTableChange(value) }
              onClickRow={value => this.onClickRow(value) }></inner-body>
          </div>
          <div v-resize={{axis: 'y', cb: this.changeY }}></div>
          <div style="width:100%;height: calc(50% - 4px);position: relative;overflow:auto">
            <inner-bodys
              height={this.height}
              data={this.StockInOrderData} 
              onReload={() => this.reload()}
              onReloadEdit={() => this.reloadEdit()}
            ></inner-bodys>
          </div>
        </div>
        {this.addNewVisible ? <creat-modal
          stockInList={this.stockInList}
          selectId={this.selectId}
          areaId={this.areaId}
          staff={this.staff}
          depts={this.depts}
          supplierList={this.supplierList}
          visible={this.addNewVisible}
          onClose={() => this.addClose()}
          onReload={() => this.reload()}
        ></creat-modal> : null}
        {this.editVisible ? <edit-modal
          stockInList={this.stockInList}
          selectId={this.selectId}
          areaId={this.areaId}
          staff={this.staff}
          depts={this.depts}
          defaultData={this.defaultData}
          supplierList={this.supplierList}
          visible={this.editVisible}
          onClose={() => this.editClose()}
          onReloadEdit={() => this.reloadEdit()}
        ></edit-modal> : null}
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </blank-view>
    )
  }
}
